export default [
  [`Российский размер`, `42-44`, `46-48`, `50-52`, `54-56`, `58-60`],
  [`Объём груди`, `104-110`, `114-118`, `120-124`, `128-132`, `134-136`],
  [`Длина изделия`, `75`, `75`, `75`, `75`, `75`]
];
